export type MStatChipDotColour = "blue" | "red" | "green" | "yellow" | (string & {}); // allows any CSS colour (hex, rgb, etc.) with palette autocomplete

export interface MStatChipProps {
  label: string;
  value?: string | number;
  dotColour?: MStatChipDotColour;
  selected?: boolean;
}

export const mStatChipDefaults = {
  selected: false,
} satisfies Partial<MStatChipProps>;
